import { Typography } from '@mui/material';
import { ProviderFullDetails } from 'pages/Dashboard/types/diagnosis.types';
import * as React from 'react';
import Theme from 'theme';


interface DoctorTextProps{
    doctor: ProviderFullDetails | null,
    width?: string | number
}


export default function DoctorDesignationText({ doctor, width }: DoctorTextProps) {
  if (!doctor || !doctor.firstName) return null;

  return (
    <Typography fontSize={16} display='inline-block' width={width}>
      {`${doctor.namePrefix} ${doctor.firstName} ${doctor.middleName} ${doctor.lastName} ${doctor.nameSuffix}`}
      <Typography fontSize={14} color={Theme.custom.colors.lightTextSecondary} display='inline-block'>
        {` (${doctor.taxonomyGroup})`}
      </Typography>
    </Typography>
  );
}
